import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { getRoleHome } from "./RoleHomeRedirect";

const ProtectedRoute = ({
    children,
    allowedRoles,
    requiresActiveMembership = false,
    allowsIncompleteOnboarding = false
}) => {
    const { authLoading, isAuthenticated, role, studentProfile } = useAuth();
    const location = useLocation();

    if (authLoading) {
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px"
            }}>
                正在確認登入狀態...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
        return <Navigate to={getRoleHome(role)} replace />;
    }

    if (
        role === "student"
        && !allowsIncompleteOnboarding
        && (
            studentProfile?.onboarding?.required === true
            // 管理員替已啟用的英文班學生重設密碼後，學生下次登入必須先自己設定新密碼。
            || (studentProfile?.authentication_method === "academy_username" && studentProfile?.must_change_password === true)
        )
    ) {
        return <Navigate to="/student/onboarding" replace state={{ from: location }} />;
    }

    if (
        requiresActiveMembership
        && role === "student"
        && !studentProfile?.membership?.is_active
    ) {
        return <Navigate to="/student/membership" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
